// src/stores/doctors.js

import { ref } from "vue";
import { defineStore } from "pinia";
import { useToast } from "vue-toastification";
import apiClient from '@/axios';
import { useConfirm } from '@/stores/composables.js'

const toast = useToast();

export const useDoctorsStore = defineStore("doctors", () => {
  const doctorsList = ref([]);
  const loading = ref(false);
  const pagination = ref({ total: 0, current_page: 1, per_page: 20 });
  const searchQuery = ref("");

  async function fetchDoctors(page = 1) {
    loading.value = true;
    try {
      const requestBody = {
        filters: [], //  اضافه کردن فیلترهای دلخواه
        page,
        perPage: pagination.value.per_page,
        searchColumn: [],
        search: searchQuery.value,
        orderBy: "FDname DESC"
      };
      const response = await apiClient.post('/Doctor/GetAllAsync', requestBody);
      // جایگزینی آرایه با کپی جدید برای ردیابی تغییرات
      doctorsList.value = [...response.data.result];

      // بروزرسانی pagination با مقادیر API یا پیش‌فرض
      pagination.value = {
        total: response.data.totalCount || 0,
        current_page: response.data.currentPage || page,
        per_page: response.data.perPage || 20
      };
    } catch (error) {
      console.error("Error fetching doctors:", error);
    } finally {
      loading.value = false;
    }
  }

  async function fetchDoctorForCombo() {
    loading.value = true;
    try {
      const response = await apiClient.get('/Doctor/GetAllForCombo');
      return response.data;
    } catch (error) {
      console.error("Error fetching doctors:", error);
    } finally {
      loading.value = false;
    }
  }

  async function addDoctor(doctorData) {
    loading.value = true;
    try {
      const response = await apiClient.post('/Doctor', doctorData);

      if (response.status === 200) {
        toast.success("پزشک با موفقیت ثبت شد");
        searchQuery.value = "";
        await fetchDoctors(1); // جدول را بلافاصله بروزرسانی کن
      } else {
        toast.error("خطا در ثبت اطلاعات پزشک");
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error adding doctor:", error);
      toast.error("خطا در ثبت اطلاعات پزشک");
    } finally {
      loading.value = false;
    }
  }

  async function updateDoctor(input) {
    loading.value = true;
    try {
      const response = await apiClient.put('/Doctor', input);
      if (response.status === 200) {
        toast.success("اطلاعات پزشک با موفقیت ویرایش شد");
        await fetchDoctors(pagination.value.current_page); // جدول را بروزرسانی کن
      } else {
        toast.error("خطا در ویرایش اطلاعات پزشک");
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error updating doctor:", error);
      toast.error("خطا در ویرایش اطلاعات پزشک");
    } finally {
      loading.value = false;
    }
  }

  async function deleteDoctor(id) {
    const { confirm } = useConfirm();
    const confirmed = await confirm("آیا از حذف این پزشک اطمینان دارید؟")
    if (!confirmed) return;
    loading.value = true;
    try {
      const response = await apiClient.delete(`/Doctor/${id}`);

      if (response.status === 200) {
        toast.success("پزشک با موفقیت حذف شد");
        await fetchDoctors(pagination.value.current_page);
      } else {
        toast.error("خطا در حذف پزشک");
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error deleting doctor:", error);
      toast.error("خطا در حذف پزشک");
    } finally {
      loading.value = false;
    }
  }

  return {
    doctorsList,
    loading,
    pagination,
    searchQuery,
    fetchDoctors,
    addDoctor,
    updateDoctor,
    deleteDoctor,
    fetchDoctorForCombo
  };
});
